import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import ModalRoot from 'components/Modal/ModalRoot';
import Library from '../containers/Library';
import Encoding from '../containers/Encoding';
import Uploader from '../containers/Uploader';

const styles = theme => ({
  content: {
    backgroundColor: '#F4F8F9',
    flexGrow: 1,
    overflowX: 'hidden',
    overflowY: 'scroll',
    flexDirection: 'column',
    padding: theme.spacing(2),
  },
  titleContainer: {
    display: 'flex',
    flexWrap: 'nowrap',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  mainContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  leftContainer: {
    flexGrow: 3,
    paddingRight: 5,
  },
  rightContainer: {
    flexGrow: 1,
    paddingLeft: 5,
  },
  paper: {
    padding: 10,
  },
  libraryContainer: {
    height: '40vh',
  },
  paperTopPadding: {
    marginTop: 10,
  },
  title: {
    ...theme.Typography,
    color: '#044591',
    paddingBottom: theme.spacing(),
  },
  campaignLeftContainer: {
    backgroundColor: '#ff0',
  },
  campaignRightContainer: {
    backgroundColor: '#f00',
  },
});

export class Cms extends Component {
  constructor(props) {
    super(props);
    props.history.push('/dashboard');
    this.renderShowCampaign = this.renderShowCampaign.bind(this);
    this.renderTitleContainer = this.renderTitleContainer.bind(this);
  }

  renderTitleContainer = () => {
    const { classes, clientName } = this.props;
    return (
      <div className={classes.titleContainer}>
        <Typography className={classes.title} variant="h6" gutterBottom>
          {clientName}
        </Typography>
      </div>
    );
  };

  renderShowCampaign() {
    const { classes, encodings } = this.props;

    return (
      <Grid container spacing={3}>
        <Grid item xs={8}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Paper className={classes.paper} elevation={0}>
                <Uploader
                  onAppendFileToLibrary={file => {
                    this.props.createEncoding(this.props.match.params.id, file);
                  }}
                />
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper} elevation={0}>
                <Encoding />
              </Paper>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <Library encodings={encodings} onFileSelect={file => {}} />
        </Grid>
      </Grid>
    );
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.content}>
        {this.renderTitleContainer()}
        {this.renderShowCampaign()}
        <ModalRoot />
      </div>
    );
  }
}

export default withStyles(styles)(Cms);
